import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component:() => import('@/views/home'),
    meta:{title:"集纳共享日历"},
  },
  {
    path: '/aboutUs/index',
    name: 'aboutUs',
    component:() => import('@/views/aboutUs/index'),
    meta:{title:"关于我们"},
  }
];

// const router = new VueRouter({
//   // mode: 'history',
//   // base: process.env.BASE_URL,
//   routes,
//   scrollBehavior (to, from, savedPosition) {
//     return savedPosition;
//   },
// })

const router = new VueRouter({
  // mode: 'history',
    mode:"hash",
  // base: "/dist",
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || {y:0, x:0};
  },
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err)
}

export default router
